import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
export default {
  name: 'StopPointHubAllocationMapping',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      isLoading: false,
      resultCount: 0,
      hubZone: '',
      hubName: '',
      srcActionType: '',
      srcTouchPointName: '',
      srcHubName: '',
      srcConnectionName: '',
      srcConnectionNameData: [],
      HubZoneListData: [],
      HubNameData: [],
      allHubMaster: [],
      ClientNameData: [],
      TouchPointnameData: [],
      hubid: '',
      hubZoneObjData: {
        value: "",
        text: ""
      },
      hubNameObjData: {
        value: "",
        text: ""
      },
      TouchPointObjData: {
        value: "",
        text: ""
      },
      srcConnectionObjData: {
        value: "",
        text: ""
      },
      isZoneError: 0,
      ZoneError: '',
      isHubError: 0,
      HubError: '',
      isTouchPointError: 0,
      TouchPointError: '',
      isActionTypeError: 0,
      ActionTypeError: '',
      isConnectionError: 0,
      ConnectionError: '',
      zoneRight: '',
      clientRight: '',
      ruleRight: '',
      connectionRight: '',
      mappingDetails: [],
      searchConnectionRight: '',
      listSourceHubNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameData: [],
      listSourceHubNameData: [],
      searchConnection: '',
      searchHubId: '',
      noConnection: '',
      isClientLoaded: 0,
      TouchPointLoading: 'Please wait.. Client data is loading',
      createdBy: '',
      addmodalshow: false,
      modalShow: false,
      modaldata: '',
      hubLoading: '',
      connectionLoading: '',
      TouchPointLoading: '',
      hubzoneLoading: '',
      ruleLoading: '',
      connectiondata: [],
      srcTouchPointID: '',
      DestHubNameData: [],
      fullRouteName: '',
      AlredyAssignedHub: '',
      ConnectionLoading: false,
      isConnectionLoaded: 0,
      Selectedchkhubs: [],
      sAll: 0,
      noConnection: 0,
      isConnectionError: 0,
      ConnectionError: '',
      chkhubZoneObjData: {
        text: '',
        value: ''
      },
      chkhubZone: '',
      chkhubLoading: '',
      chkHubNameData: [],
      isvalidsearch: false,
      alreadyassignhubs: [],
      search: ''
    }
  },

  created: function() {},
  computed: {
    chkhubdataList() {
      return this.chkHubNameData.filter(list => {
        return list.text.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;

    this.getHubZone();
    this.getAllHubName()
  },
  created() {
    axios.interceptors.request.use((config) => {
      this.setLoading(true);
      return config;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.setLoading(false);
      return response;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.resultCount++;
        this.isLoading = true;
      } else if (this.resultCount > 0) {
        this.resultCount--;
        this.isLoading = (this.resultCount > 0);
      }
    },
    selectedHubZone(hubData) {
      this.isZoneError = 0;
      this.ZoneError = ''
      this.hubZoneObjData = hubData;
      this.hubZone = hubData.value;
      this.hubNameObjData = {
        value: "",
        text: ""
      }
      this.desthubNameObjData = {
        value: "",
        text: ""
      }
      this.srcConnectionObjData = {
        value: "",
        text: ""
      }
      this.srcHubName = ''
      this.destHubName = ''
      this.HubNameData = [];
      this.getHubName();
    },
    chkselectedHubZone(hubData) {

      this.chkhubZoneObjData = hubData;
      this.chkhubZone = hubData.value;
      this.chkHubNameData = [];
      this.chkgetHubName();
    },
    selectedHub(hubName) {
      this.isHubError = 0;
      this.HubError = ''
      this.isConnectionError = 0;
      this.ConnectionError = ''
      this.hubNameObjData = hubName;
      var a = this.hubNameObjData.value
      this.DestHubNameData = this.allHubMaster.filter(function(el) {
        return el.value != a
      });
      this.hubName = hubName.value;
      this.srcHubName = hubName.value
      this.srcConnectionObjData = {
        value: "",
        text: ""
      }
      this.getConnectionName();
    },
    selectedTouchPoint(touchpointname) {
      this.isTouchPointError = 0;
      this.TouchPointError = ''
      this.TouchPointObjData = touchpointname;
      this.srcTouchPointID = touchpointname.value;
      this.srcTouchPointName = touchpointname.text;
      // this.getSrcRuleName();
    },
    selectedRule(ruleName) {
      this.isActionTypeError = 0;
      this.ActionTypeError = ''
      this.srcActionTypeObjData = ruleName;
      this.ruleName = ruleName.value;
      this.srcActionType = ruleName.value

    },
    selectedConnection(connectionName) {
      this.isConnectionError = 0;
      this.ConnectionError = ''
      this.srcConnectionObjData = connectionName;
      this.connectionName = connectionName.value;
      this.srcConnectionName = connectionName.value
      this.getStopintsData(this.srcConnectionObjData, this.connectiondata);
    },
    selectedSearchHub(dta) {
      this.listConnectionNameDataObj = {
        text: '',
        value: ''
      }
      this.listSourceHubNameDataObj = dta
      this.searchHubId = dta.value
      this.mappingDetails = []
      this.getConnectionNameSearch()
    },
    selectedHubConnection(data) {
      this.listConnectionNameDataObj = data
      this.searchConnection = data.value
    },
    //to get hubzone list start
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      this.resultCount = 0;
      this.zoneRight = this.rightLoader
      // this.HubZoneListData=[];
      // this.input = ({
      // 	hubName: this.hubzonename,
      // })
      this.input = ({});
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          self.zoneRight = ''
          //this.HubZoneListData = result.data.data
          var HubZoneListData = result.data.ResponseData;
          for (i = 0; i < HubZoneListData.length; i++) {
            this.HubZoneListData.push({
              value: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }, error => {
          self.zoneRight = ''
          console.error(error)
        })
    },
    //to get hubname list start
    getHubName() {
      this.HubNameData = [];
      this.allHubMaster = [];
      this.DestHubNameData = [];
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubZone,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
            this.allHubMaster = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    chkgetHubName() {
      this.chkHubNameData = [];
      this.chkhubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.chkhubZone,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.chkhubLoading = ''
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.chkHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    getAllHubName() {
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.listSourceHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    //to get clientname list start
    //to get connection
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      self.srcConnectionNameData = [];
      self.TouchPointnameData = [];
      this.resultCount = 0;
      this.input = {
        source: parseInt(self.hubNameObjData.value)
      }
      self.isLoading = true
      self.connectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.connectionLoading = ''
          self.connectionRight = ''
          self.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData;
            this.connectiondata = result.data.ResponseData;
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.srcConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName
              })
            }
          } else {
            self.isConnectionError = 1;
            self.ConnectionError = 'No Connection Found'
          }
        }, error => {
          this.connectionLoading = ''
          self.connectionRight = ''
          self.isLoading = false
          self.isConnectionError = 0;
          self.ConnectionError = ''
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },
    getStopintsData(connection, connectiondata) {
      this.TouchPointnameData = [];
      this.fullRouteName = '';
      this.TouchPointLoading = 'Loading Client...'
      var connectionid = connection.value;
      var connectionstopintsdata = connectiondata.filter(obj => obj.ConnectionID == connectionid);
      var stoppoints = connectionstopintsdata[0].Stoppoints;
      for (var i = 0; i < stoppoints.length; i++) {
        this.TouchPointnameData.push({
          value: stoppoints[i].StopPointHubId,
          text: stoppoints[i].StopPointName
        })
      }
      this.fullRouteName = connectionstopintsdata[0].FullConnectionName
      this.TouchPointLoading = ''

    },
    getConnectionNameSearch() {
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      self.noConnection = ''
      self.listConnectionNameData = []
      this.resultCount = 0;
      this.input = {
        source: parseInt(self.listSourceHubNameDataObj.value)
      }
      self.isLoading = true
      self.searchConnectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          self.searchConnectionRight = ''
          self.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.listConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName
              })
            }
          } else {
            self.noConnection = 'No Connection Found'
          }
        }, error => {
          self.searchConnectionRight = ''
          self.isLoading = false
          self.noConnection = ''
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },

    //to reset search form
    resetForm() {
      this.isLoading = false
      this.hubZone = ''
      this.hubName = ''
      this.srcActionType = ''
      this.srcTouchPointName = ''
      this.srcHubName = ''
      this.srcConnectionName = ''
      this.hubid = ''
      this.hubZoneObjData = {
        value: "",
        text: ""
      }
      this.hubNameObjData = {
        value: "",
        text: ""
      }
      this.TouchPointObjData = {
        value: "",
        text: ""
      }
      this.srcConnectionObjData = {
        value: "",
        text: ""
      }
      this.chkhubZoneObjData = {
        value: "",
        text: ""
      }
      this.isZoneError = 0
      this.ZoneError = ''
      this.isHubError = 0
      this.HubError = ''
      this.isTouchPointError = 0
      this.TouchPointError = ''
      this.isActionTypeError = 0
      this.ActionTypeError = ''
      this.isConnectionError = 0
      this.ConnectionError = ''
      this.srcConnectionNameData = [];
      this.chkHubNameData = [];
      this.isvalidsearch = false;
      this.Selectedchkhubs = [];
      this.alreadyassignhubs = [];
      this.fullRouteName = '';
      this.search = '';
    },
    resetSearchForm() {
      this.hubZone = '';
      this.srcHubName = '';
      this.srcTouchPointName = '';
      this.srcActionType = '';
      this.srcConnectionName = '';
    },

    //validate all form fields on onsubmit()
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    checkFormError() {
      var isError = 0
      if (this.hubZone == '') {
        this.isZoneError = 1
        this.ZoneError = 'Select Zone'
        isError = 1
      } else {
        this.isZoneError = 0
        this.ZoneError = ''
      }
      if (this.srcHubName == '') {
        this.isHubError = 1
        this.HubError = 'Select Hub'
        isError = 1
      } else {
        this.isHubError = 0
        this.HubError = ''
      }
      if (this.srcTouchPointName == '') {
        this.isTouchPointError = 1
        this.TouchPointError = 'Select Touch Point'
        isError = 1
      } else {
        this.isTouchPointError = 0
        this.TouchPointError = ''
      }
      if (this.srcActionType == '') {
        this.isActionTypeError = 1
        this.ActionTypeError = 'Select Action Type'
        isError = 1
      } else {
        this.isActionTypeError = 0
        this.ActionTypeError = ''
      }
      if (this.srcConnectionName == '') {
        this.isConnectionError = 1
        this.ConnectionError = 'Select Connection'
        isError = 1
      } else {
        this.isConnectionError = 0
        this.ConnectionError = ''
      }
      return isError;
    },
    getBaggingData() {
      if (this.checkFormError()) {
        console.log('InValid');
        return false;
      }
      var self = this
      var input = {
        //"csrId": self.hubZone,
        // "ConnectionID": self.srcConnectionName,
        // "TouchPointID": self.srcTouchPointID,
        // "Type": self.srcActionType,
      }
      self.AlredyAssignedHub = ''
      self.isvalidsearch = true;
      self.Selectedchkhubs = [];
      self.alreadyassignhubs = [];
      this.ConnectionLoading = true;

      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getStopPointAllocatedHubs?ConnectionID=" + self.srcConnectionName + "&TouchPointID=" + self.srcTouchPointID + "&Type=" + self.srcActionType,
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          this.ConnectionLoading = false;
          if (result.data.ResultCode == 100) {
            var list = [];
            for (var i = 0; i < result.data.ResponseData.length; i++) {
              if (self.srcActionType == "InScan") {
                list.push(result.data.ResponseData[i].inscanhubid)
              } else {
                list.push(result.data.ResponseData[i].stoppointoutscanhubid)
              }

            }
            self.Selectedchkhubs = list;
            self.alreadyassignhubs = list;
            var cnt = 0;
            self.AlredyAssignedHub = 'Total Allocated  Hubs : ' + list.length
            self.markCheck()
          } else {
            self.AlredyAssignedHub = 'Total Allocated  Hubs : 0';
          }
        }, error => {
          this.ConnectionLoading = false;
          console.error(error)
        })
    },
    selectAll() {
      this.sAll = this.sAll == 1 ? 0 : 1
      this.isConnectionError = 0,
        this.ConnectionError = ''
      // console.log("selectAll");
      if (this.sAll == 1) {
        this.chkHubNameData.forEach((connect) => {
          this.Selectedchkhubs.indexOf(connect.value) == -1 ? this.Selectedchkhubs.push(connect.value) : ''
        })
        //console.log(this.Selectedchkhubs);
      } else {
        this.Selectedchkhubs = []
      }
    },
    markCheck() {
      this.isConnectionError = 0,
        this.ConnectionError = ''
      if (this.chkHubNameData.length > 0 && (this.Selectedchkhubs.length >= this.chkHubNameData.length)) {
        this.sAll = 1
      } else {
        this.sAll = 0
      }
    },

    setBlackColor() {
      this.AlredyAssignedHub = ''
      for (var x = 0; x < this.chkHubNameData.length; x++) {
        document.getElementById('connect_' + this.chkHubNameData[x].value) ? document.getElementById('connect_' + this.chkHubNameData[x].value).style.color = '#000' : ''
      }
    },
    saveBaggingData() {
      if (this.checkFormError()) {
        console.log('InValid');
        return false;
      }
      var self = this;
      var newassugnedhubs = [];
      //console.log(this.alreadyassignhubs,this.Selectedchkhubs);
      // for(var i=0;i<this.Selectedchkhubs.length;i++){
      //   if(this.alreadyassignhubs.indexOf(this.Selectedchkhubs[i])==-1){
      //     newassugnedhubs.push(this.Selectedchkhubs[i])
      //   }
      // }
      // if(newassugnedhubs.length==0){
      //   this.$alertify.error("No New Hubs Assigned");
      //   return false;
      // }
      var input = {
        //"csrId": self.hubZone,
        "ConnectionID": self.srcConnectionName,
        "TouchPointID": self.srcTouchPointID,
        "Type": self.srcActionType,
        "SourceHubID": self.srcHubName,
        "ScanLocations": self.Selectedchkhubs.join(","),
        "CreatedBy": self.createdBy
      }
      this.input = input;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "stopPointHubAllocation",
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            //  this.resetForm();
            this.getBaggingData();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/components/StopPointHubAllocationMapping/StopPointHubAllocationMapping.component.js